import React from 'react';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import Services from '../components/Services';
import Solutions from '../components/Solutions';
import Industries from '../components/Industries';

const Home = () => {
  return (
    <div className="min-h-screen bg-gray-950">
      <Hero />
      <Stats />
      <Services />
      <Solutions />
      <Industries />
    </div>
  );
};

export default Home;